module.exports = __webpack_public_path__ + "static/media/101.f2c4e199.png";